//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'HuntHess_info',
}



// WEBPACK FOOTER //
// ./src/pages/formulasInfo/Neuro/Chart_HuntHess_info.vue